import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Popover } from 'react-bootstrap';

class DetailsPopover extends React.Component {

    constructor(props, context) {
        super(props, context);

        let positionLeft = this.props.positionLeft;
        let placement = "left";

        this.state = {
            positionLeft: positionLeft,
            positionTop: (this.props.positionTop < 0) ? 0 : this.props.positionTop,
            placement: placement,
            parent: this.props.parent,
            smartPopoverPlacement: this.props.smartPopoverPlacement
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        let positionLeft = nextProps.positionLeft;
        let placement = "left";

        this.setState({
            positionLeft: positionLeft,
            positionTop: (nextProps.positionTop < 0) ? 0 : nextProps.positionTop,
            placement: placement,
            parent: nextProps.parent,
        });
    }

    // RENDER METHOD

    render = () => {
        return (
            <Popover placement={this.state.placement} positionLeft={this.state.positionLeft} positionTop={this.state.positionTop} >
                <form>
                    <div> Rejected: {this.props.formattedPrevRejected} <span style={this.props.formattedPrevOvertimeRejected ? {"color" : "red"} : {}}>{this.props.formattedPrevOvertimeRejected ? " + " + this.props.formattedPrevOvertimeRejected : ""}</span> </div>
                    <div> Rejected: {this.props.rejected} </div>
                    <div style={{wordWrap : "break-word"}}> {this.props.message}</div>
                </form>
            </Popover>
        );
    }
}

DetailsPopover.propTypes = {
    formattedPrevOvertimeRejected: PropTypes.string,
    formattedPrevRejected: PropTypes.string,
    message: PropTypes.string,
    parent: PropTypes.object,
    positionLeft: PropTypes.number,
    positionTop: PropTypes.number,
    rejected: PropTypes.string,
    smartPopoverPlacement: PropTypes.bool
};

export default connect()(DetailsPopover);


/** WEBPACK FOOTER **
 ** ./src/app/components/DetailsPopover.js
 **/